<template>
    <Modal v-if="visible" @cancel="$emit('close')">
        <ModalCard
            :active-validate="false"
            :contentMaxHeight="height"
            :headerTitle="$t('modale.preavisIntervention.create.title')"
            :height="height"
            :maxWidth="maxWidth"
            :width="width"
            :withoutBotNav="true"
            @cancel="$emit('close')"
        >
            <div class="modal-body">
                <div class="message-container">
                    <h2>{{ $t('preavisIntervention.confirmation') }}</h2>
                </div>

                <div class="actions-bar">
                    <ButtonWhite :on-click="() => $emit('close')" :text="$t('button.close')" class="btn-left btn" />
                    <div class="btn-right-group">
                        <ButtonWhite
                            :on-click="() => $emit('mes-preavis')"
                            :text="$t('preavisIntervention.consulter')"
                            class="btn"
                        />
                        <ButtonBlue
                            v-if="!hideNouveauPreavis"
                            :on-click="() => $emit('nouveau-preavis')"
                            :text="$t('preavisIntervention.nouveau')"
                            class="btn"
                        />
                    </div>
                </div>
            </div>
        </ModalCard>
    </Modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Modal from '@/components/ui-components/Modal.vue';
import ModalCard from '@/components/ui-components/ModalCard.vue';
import ButtonBlue from '@/components/ui-components/ButtonBlue.vue';
import ButtonWhite from '@/components/ui-components/ButtonWhite.vue';

export default defineComponent({
    name: 'PreavisConfirmationCreatedModal',
    components: { Modal, ModalCard, ButtonBlue, ButtonWhite },
    props: {
        visible: { type: Boolean, required: true },
        hideNouveauPreavis: { type: Boolean, default: false },
        width: { type: String, default: '45vw' },
        maxWidth: { type: String, default: '50%' },
        height: { type: String, default: '10vw' },
    },
    emits: ['close', 'mes-preavis', 'nouveau-preavis'],
});
</script>

<style scoped>
.modal-body {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: v-bind(height);
}

.message-container {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 16px;
}

.actions-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 8px;
}
.btn {
    width: 120px;
    border-radius: 5px;
    cursor: pointer;
    height: 40px;
    margin-top: 10px;
}
.btn-right-group {
    display: flex;
    gap: 12px;
}
</style>
